import { render, staticRenderFns } from "./ViFeePayment.vue?vue&type=template&id=1cdaa4c8&scoped=true"
import script from "./ViFeePayment.vue?vue&type=script&lang=js"
export * from "./ViFeePayment.vue?vue&type=script&lang=js"
import style0 from "./ViFeePayment.vue?vue&type=style&index=0&id=1cdaa4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdaa4c8",
  null
  
)

export default component.exports